import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Button from "../utilities/button/Button";
import ClientRow from "./ClientRow";
import styles from "./PotentialClient.module.css";
import FormSelect from "../utilities/formSelect/FormSelect";

function PotentialClient() {
  const [overlap, setOverlap] = useState(false);
  const [clientId, setClienId] = useState("");
  const [deleteStatus, setDeleteStatus] = useState("deleted");
  const [deleteBtn, setDeleteBtn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [countrySearch, setCountrySearch] = useState("");
  const [countryList, setCountryList] = useState([]);

  // Params Parameters
  const [searchParams, setSearchParams] = useSearchParams();

  // GET THE COUNTRY DATA
  useEffect(() => {
    async function getCountry() {
      try {
        const result = await fetch(
          `https://artmadein-dashboard-backend.onrender.com/api/v1/client/clientcountry`,
          // `http://localhost:5000/api/v1/client/clientcountry`,
          {
            method: "GET",
            credentials: "include",
          }
        );
        const data = await result.json();
        setCountryList(data.data.stats);
      } catch (err) {
        console.log(err);
      }
    }

    getCountry();
  }, []);

  // PARAM
  function CountryParam(e) {
    setCountrySearch(e.target.value);
    const newParam = new URLSearchParams(searchParams);

    // newParam.set("type", "e-commerce");
    newParam.set("country", e.target.value);

    // Remove if empty
    if (!e.target.value) {
      newParam.delete("country");
    }

    // Update Url
    setSearchParams(newParam);
  }

  useEffect(() => {
    async function getClient() {
      try {
        const queryString = new URLSearchParams(searchParams).toString();
        const result = await fetch(
          `https://artmadein-dashboard-backend.onrender.com/api/v1/client/getpotentialclient?${queryString}`,
          // `http://localhost:5000/api/v1/client/getpotentialclient?${queryString}`,
          {
            method: "GET",
            credentials: "include",
          }
        );

        if (!result.ok) {
          throw new Error("Network response was not ok");
        }

        const finalData = await result.json();
        setData(finalData.data);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching data:", error);
        setError(error);
        setLoading(false);
      }
    }
    getClient();
  }, [searchParams]);

  async function deleteHandler() {
    setDeleteStatus("deleting");
    setDeleteBtn(true);
    try {
      const result = await fetch(
        `https://artmadein-dashboard-backend.onrender.com/api/v1/client/clientdelete/${clientId}`,
        // `http://localhost:5000/api/v1/client/clientdelete/${clientId}`,
        {
          method: "DELETE",
          credentials: "include",
        }
      );
      console.log(result);
      if (result.ok) {
        setOverlap(false);
        reload();
        setDeleteStatus("deleted");
        setDeleteBtn(false);
      }
    } catch (err) {
      console.log(err);
    }
  }

  function reload() {
    window.location.reload();
  }

  function OverlapHandler(clientId) {
    setOverlap(true);
    setClienId(clientId);
  }

  function cancelOverlapHandler() {
    setOverlap(false);
  }

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingBox}>
          <h1 className={styles.loadingHeading}>Loading...</h1>
        </div>
      </div>
    );
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <>
      <div
        className={
          overlap ? `${styles.overlap}` : `${styles.overlapBoxCollapse}`
        }
      >
        <div className={styles.overlapBox}>
          <p className={styles.overlapPara}>
            Do you want to delete the client?
          </p>
          <div className={styles.deleteBox}>
            <button
              onClick={deleteHandler}
              style={{
                padding: "10px 20px",
                border: "1px solid var(--mainColor)",
                backgroundColor: "white",
                cursor: "pointer",
              }}
              disabled={deleteBtn}
            >
              {deleteStatus === "deleting" && <p>Wait...</p>}
              {deleteStatus === "deleted" && <p>Delete</p>}
            </button>
            <Button handleClick={cancelOverlapHandler}>Cancel</Button>
          </div>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.box}>
          <h1 className={styles.heading}>Potential Client List</h1>
          <div style={{ marginBottom: "50px" }}>
            <div>
              <select onChange={CountryParam} value={countrySearch}>
                <option value="">all</option>
                {countryList.map((data, index) => {
                  return (
                    <FormSelect
                      key={index}
                      country={data._id}
                      number={data.count}
                    ></FormSelect>
                  );
                })}
              </select>
            </div>
          </div>
          <div className={styles.clientBox}>
            <table className={styles.clientTable}>
              <thead>
                <tr style={{ height: "100px" }}>
                  <th className={styles.clientTh}>Company Name</th>
                  <th className={styles.clientTh}>Country</th>
                  <th className={styles.clientTh}>Email ID</th>
                  <th className={styles.clientTh}>Instagram ID</th>
                  <th className={styles.clientTh}>Facebook ID</th>
                  <th className={styles.clientTh}>Linkedin ID</th>
                  <th className={styles.clientTh}>Created By</th>
                  <th className={styles.clientTh}>View Details</th>
                  <th className={styles.clientTh}>Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((client) => {
                  return (
                    <ClientRow
                      key={client._id}
                      companyName={client.companyName}
                      country={client.country}
                      email={client.email}
                      instagramId={client.instagramId}
                      facebookId={client.facebookId}
                      linkedinId={client.linkedinId}
                      createdBy={client?.createdBy?.userName ?? "NoData"}
                      clientId={client._id}
                      OverlapHandler={OverlapHandler}
                    ></ClientRow>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default PotentialClient;
